import { makeStyles, Theme } from "@material-ui/core/styles";
import { Box } from "common";
import { SearchBox, SelectCountry } from "custom";
import React, {useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLocation, setStoreId, switchStore } from "store/actions/auth.actions";
import { resetFilters, setSearchTerm } from "store/actions/promotion.actions"; //fetchCampaigns,
import { EStores } from "store/reducers/auth.reducers";
import { IState } from "store/store.interface";
import { useLocation } from "wouter";
import { fetchBulkBundleJobs } from "store/actions/bulkBundleUtility.actions";
import { fetchBundleCampaigns } from "store/actions/bundlePromotion.actions";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    padding: "0 20px",
    justifyContent: "space-beween",
    alignItems: "center",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      padding: "0px 15px",
      width: "100%",
    },
  },
}));
const Header: React.FC = () => {
  const { container } = useStyles();
  const dispatch = useDispatch();
  const { storeId = "", bundleAllowedCountries = [] } = useSelector(
    (state: IState) => ({
      ...state.config,
      ...state.auth,
    })
  );

  const [location] = useLocation();

  const onChangeCountry = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newStoreId = event.target.value as EStores;
    dispatch(setStoreId(newStoreId));
    dispatch(switchStore(newStoreId, () => {
      if (
        location === "/cart-bundles" &&
        bundleAllowedCountries.includes(newStoreId)
      ) {
        dispatch(fetchBundleCampaigns());
      } else if (
        location === "/bulk-campaign-jobs" &&
        bundleAllowedCountries.includes(newStoreId)
      ) {
        dispatch(fetchBulkBundleJobs());
      } else if (
        location === "/cart-bundle-help" &&
        bundleAllowedCountries.includes(newStoreId)
      ) {
        dispatch(setLocation("/cart-bundle-help"));
      } else {
        dispatch(resetFilters());
        dispatch(setLocation("/"));
      }
    }));
  };

  useEffect(() => {
    dispatch(setSearchTerm(""));
  }, [dispatch]);

  return (
    <Box className={container}>
      <SearchBox placeholder="Search for a campaign" />
      <Box display="flex" justifyContent="flex-end">
        <SelectCountry
          onChangeCountry={onChangeCountry}
          value={storeId}
          width="230px"
          fullWidth={false}
          disableUnderLine={true}
        />
      </Box>
    </Box>
  );
};

export default Header;
